import Pair from "./Pair"

class PlayerPair extends Pair {

}

export default PlayerPair
